import { render, staticRenderFns } from "./finalGroupList.vue?vue&type=template&id=4187d36c&scoped=true&"
import script from "./finalGroupList.vue?vue&type=script&lang=js&"
export * from "./finalGroupList.vue?vue&type=script&lang=js&"
import style0 from "./finalGroupList.vue?vue&type=style&index=0&id=4187d36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187d36c",
  null
  
)

export default component.exports